import { useState } from "react";
import {Table, Tbody, Td, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Pagination from "components/ui/pagination/Pagination";

export default function ShiftsDataTable({ data }) {
  const { t } = useTranslation();
  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (data, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
    return data?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const shiftsData = calculateRecords(
    data,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return (
    <>
      <>
        <Table>
          <Thead>
            <Tr>
              <Th>{t("pages.reports.reports_tables.user")}</Th>
              <Th>{t("pages.reports.reports_tables.branch")}</Th>
              <Th>{t("pages.reports.reports_tables.branch_reference")}</Th>
              <Th>{t("pages.reports.reports_tables.clocked_in_at")}</Th>
              <Th>{t("pages.reports.reports_tables.clocked_out_at")}</Th>
              <Th>{t("pages.reports.reports_tables.shift_duration")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {shiftsData?.map((item, index) => (
              <Tr key={index}>
                <Td>{item?.User}</Td>
                <Td>{item?.BranchName}</Td>
                <Td> {item?.BranchReference} </Td>
                <Td> {item?.ClockedInAt} </Td>
                <Td> {item?.ClockedOutAt} </Td>
                <Td> {item?.ShiftDuration} </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          currentPage={currentPageActive}
          setCurrentPage={setCurrentPageActive}
          npage={Math.ceil(data?.length / recordsPerPage)}
          prePage={() => prePage(currentPageActive, setCurrentPageActive)}
          nextPage={() =>
            nextPage(
              currentPageActive,
              setCurrentPageActive,
              Math.ceil(data?.length / recordsPerPage)
            )
          }
        />
      </>
    </>
  );
}
